import {Notification} from '../../API';

import {DataSource, FilterSchema} from "./DataSource";

import {listNotifications} from "./requests/listNotifications";

import {onCreateNotification, onUpdateNotification, onDeleteNotification} from "../../graphql/subscriptions";
import { UserDataSourceDeps } from "../../platform/services/types/DataSourceDependencies";


export class NotificationsDataSource extends DataSource<Notification, Notification, UserDataSourceDeps> {
    static modelName = 'Notification';
    readonly _modelName = 'Notification' as const;
    readonly _subscriptionGQLs = {
        onCreate: onCreateNotification,
        onUpdate: onUpdateNotification,
        onDelete: onDeleteNotification,
    } as const;

    constructor(deps: UserDataSourceDeps) {
        super(deps);
    }

    get syncQueryFilter() {
        return {
            userId: {
                eq: this.deps.userState.currentUserId
            },
        }
    }

    get syncHash() {
        return this.deps.userState.currentUserId!;
    }

    getFilterDefaultValues(): {} {
        return {
            status: 'all',
        }
    }

    getFilterSchema(): FilterSchema<Notification> {
        return {
            status: {
                type: 'client',
                apply: (row: Notification) => {
                    if (this.filterValues.status === 'all') {
                        return row.status !== 'deleted';
                    } else {
                        return row.status === this.filterValues.status
                    }
                }
            }
        }
    }

    loadGQLFetch() {
        return listNotifications(
            this.deps.dataClientService,
            this.deps.authService,
            this.deps.userState.tenantId,
            this.deps.userState.currentUserId!
        );
    };

    loadMoreGQLFetch(nextToken: string) {
        return listNotifications(
            this.deps.dataClientService,
            this.deps.authService,
            this.deps.userState.tenantId,
            this.deps.userState.currentUserId!,
            nextToken
        );
    };

    getWsClient() {
        return this.deps.dataClientService.getWsClientForTable('notifications');
    };
}
